import Link from "next/link";

import { cn } from "@/lib/utils";

/**
 * Prosa wordmark — typographic, IBM Plex Serif, in --ink.
 * The mark is three short stacked horizontal bars of decreasing width,
 * echoing the federal → local jurisdiction stack. CSS/SVG only.
 */
export function ProsaMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 20 16"
      fill="none"
      aria-hidden="true"
      className={cn("h-4 w-5", className)}
    >
      <rect x="0" y="1" width="20" height="3" rx="1.5" fill="currentColor" />
      <rect x="0" y="6.5" width="14" height="3" rx="1.5" fill="currentColor" opacity="0.7" />
      <rect x="0" y="12" width="8" height="3" rx="1.5" fill="currentColor" opacity="0.45" />
    </svg>
  );
}

export function Wordmark({
  className,
  href = "/",
}: {
  className?: string;
  href?: string | null;
}) {
  const content = (
    <span className={cn("inline-flex items-center gap-2.5 text-ink", className)}>
      <ProsaMark className="text-primary" />
      <span className="font-serif text-2xl font-semibold tracking-tight">
        Prosa
      </span>
    </span>
  );

  if (href === null) {
    return content;
  }

  return (
    <Link href={href} className="inline-flex items-center" aria-label="Prosa home">
      {content}
    </Link>
  );
}
